exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DrawerContainer {\n  width: 100%;\n  z-index: 403;\n  position: absolute;\n  overflow: scroll;\n  bottom: 0;\n  top: 0;\n  background-color: rgba(58, 58, 58, 0.9);\n  display: block;\n  margin: 0 -20px;\n  /*border-top: 1px outset #ffffff;*/\n}\n\n.desktop .DrawerContainer {\n  position: relative;\n  bottom: 20px;\n  overflow: hidden;\n  pointer-events: none;\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/scenes/MapContainer/components/DrawerContainer/DrawerContainer.css
// module id = 880
// module chunks = 0